import { required } from "@vuelidate/validators";

import Tipo from "./tipo";
import SubUnidade from "./subUnidade";

export default class Registro {
    constructor() {
        this.id = null;
        this.periodo = null;
        this.valor = null;
        this.tipo = new Tipo();
        this.subUnidade = new SubUnidade();
    }

    validations() {
        return {
            periodo: {
                required,
            },
            valor: {
                required,
            },
            tipo: {
                id: {
                    required,
                }
            },
            subUnidade: {
                id: {
                    required,
                }
            },
        };
    }
}